import React, { Component } from "react";
import Introduction from "../../components/adsAgencies/Introduction";
import MainContent from "../../components/adsAgencies/mainContent";

import "../../../assets/styles/base.css";
import "../../../assets/styles/views/containers/adsAgencies.css";

export default () => {
  return (
    <div>
      <Introduction />
      <MainContent />
    </div>
  );
};
